import {
  Box,
  Card,
  Checkbox,
  Typography,
} from "@mui/material";
import React, { ChangeEvent, useState, useEffect } from "react";

import { FuncionarioSistemasLiberados } from "./FuncionarioSistemaLiberado";
import { useSistemaStorage } from "../../../../Storage/SistemaStorage";
import { useUsuarioStorage } from "../../../../Storage/UsuariosStorage";
import { useUsuario } from "../../../../Hooks/UsuarioHook";
import { useEntidade } from "../../../../Hooks/EntidadeHook";
export interface FormData {
  foto: string;
  nome: string;
  tipoPessoa: string;
  cpf: string;
  cnpj: string;
  sexo: string;
  dataNascimento: string;
  descricao: string;
  telefone: string;
  email: string;
  endereco: string;
  bairro: string;
  cidade: string;
  uf: string;
  cep: string;
  zonaRural: boolean;
  localidadeRural: string;
  administrador: boolean;
  inativo: boolean;
  senha: string;
  confirmarSenha: string;
  servidor: boolean;
  complemento: string;
}
interface Props {

  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  formValid: boolean;
  setFormValid: React.Dispatch<React.SetStateAction<boolean>>;
}



export const Configuracoes = ({
  formData,
  setFormData,
  formValid,
  setFormValid,
}: Props) => {

  const { usuarioFocus } = useUsuarioStorage();
  const { libera_bloqueia_sistema_por_usuario, } = useSistemaStorage();
  const { usuario } = useUsuario();
  const { atualiza_criaUsuario } = useUsuarioStorage()
  const { entidadeFocus } = useEntidade()

  const handleCheckboxChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;

    // Atualiza o estado local
    const novoFormData = {
      ...formData,
      [name]: checked,
    };
    setFormData(novoFormData);

    // Monta o FormData com base apenas nos campos do passo 4
    const params = new FormData();

    if (usuarioFocus?.usuario?.id) {
      params.append("id", String(usuarioFocus.usuario.id));
    } else if (usuario?.usuario?.entidade_id) {
      params.append("entidade_id", usuario.usuario.entidade_id.toString());
    } else {
      params.append("entidade_id", String(entidadeFocus.id));
    }

    params.append("administrador", String(name === "administrador" ? checked ? "1" : "0" : novoFormData.administrador ? "1" : "0"));
    params.append("servidor", String(name === "servidor" ? checked ? "1" : "0" : novoFormData.servidor ? "1" : "0"));

    if (name === "inativo") {
      if (checked) {
        params.append("inativo", new Date().toISOString());
      } else {
        params.append("inativo", "null"); // backend interpreta como null
      }
    }

    await atualiza_criaUsuario(params);
  };


  // useEffect(() => {
  //   const executarLiberacoes = async () => {
  //     if (formData.servidor) {
  //       for (const id of FuncionarioSistemasLiberados) {
  //         await libera_bloqueia_sistema_por_usuario(
  //           usuarioFocus.usuario.id,
  //           id,
  //           0
  //         );
  //       }
  //     } 
  //   };

  //   executarLiberacoes();
  // }, [formData.servidor]);



  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {/* Administrador */}
      <Card
        variant="outlined"
        sx={{
          p: 1.5,
          borderRadius: 2,
          backgroundColor: "action.hover",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Checkbox
          checked={formData.administrador}
          onChange={handleCheckboxChange}
          name="administrador"
          size="small"
        />
        <Box>
          <Typography variant="body1" fontWeight="bold">
            Administrador
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Acesso total a configurações e gerenciamento de usuários.
          </Typography>
        </Box>
      </Card>

      {/* Funcionário */}
      <Card
        variant="outlined"
        sx={{
          p: 1.5,
          borderRadius: 2,
          backgroundColor: "action.hover",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Checkbox
          checked={formData.servidor}
          onChange={handleCheckboxChange}
          name="servidor"
          size="small"
        />
        <Box>
          <Typography variant="body1" fontWeight="bold">
            Funcionário
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Acesso a funcionalidades específicas para funcionários.
          </Typography>
        </Box>
      </Card>

      {/* Inativo */}
      <Card
        variant="outlined"
        sx={{
          p: 1.5,
          borderRadius: 2,
          backgroundColor: "rgba(239,68,68,0.08)",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          borderColor: "error.main",
        }}
      >
        <Checkbox
          checked={formData.inativo}
          onChange={handleCheckboxChange}
          name="inativo"
          size="small"
        />
        <Box>
          <Typography variant="body1" fontWeight="bold" color="error">
            Inativo
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Usuário perderá acesso a todos os sistemas.
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};
